import { z } from 'zod';
import { ErrorCode } from '../../../../shared/error-codes';
/**
 * Pre-check a lead email before the partner picks an appointment: the flow must
 * not let a partner book a Calendly slot for a contact the partner already
 * submitted. The check is scoped to the calling partner's own lead book —
 * duplicates elsewhere in the CRM are resolved by Bliks service downstream and
 * are deliberately not disclosed here.
 */ export const PrecheckPartnerLeadRequestSchema = z.object({
    email: z.email(ErrorCode.USER_INVALID_EMAIL)
});
export const PrecheckPartnerLeadResponseSchema = z.object({
    /** True if this email is already one of the partner's own leads. */ exists: z.boolean()
});

//# sourceMappingURL=precheck-partner-lead.schema.js.map